// src/components/common/CustomButton/index.js
import React from 'react';
import { Button } from '@zebra-fed/zds-react-desktop';
import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: flex;

  @media screen and (max-width: 750px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

const getCustomStyles = (type, disabled) => {
  const base = {
    borderRadius: '4px',
  };

  if (disabled) {
    return {
      ...base,
      backgroundColor: '#E8EBF1',
      color: '#929AA9',
      border: 'none',
    };
  }

  switch (type) {
    case 'primary':
      return {
        ...base,
        backgroundColor: '#0073E6',
        color: '#FFFFFF',
        border: 'none',
      };
    case 'outlined':
      return {
        ...base,
        backgroundColor: 'transparent',
        color: '#0073E6',
        border: '1px solid #0073E6',
      };
    case 'secondary':
      return {
        ...base,
        backgroundColor: '#757575',
        color: '#FFFFFF',
        border: 'none',
      };
    default:
      return base;
  }
};

export const CommonButton = ({
  children,
  type = 'default',
  disabled = false,
  style = {},
  dense = false,
  ...props
}) => {
  return (
    <Button
      {...props}
      type={type}
      dense={dense}
      disabled={disabled}
      style={{
        ...getCustomStyles(type, disabled),
        ...style
      }}
    >
      {children}
    </Button>
  );
};